import { Container } from "@mui/material";
import Footer from "../components/Footer";
import AllPrograms from "./AllPrograms";
import QuranicPrograms from "./QuranicPrograms";
import UndergraduatePrograms from "./UndergraduatePrograms";


const Programs = ()=>{


    return (
        <>
            <Container sx={{my:4, py:2,border: '2px solid var(--primary)', borderRadius: 2}}>
                
                <AllPrograms type={"quranic"} title={"Islamic"} subtitle={"Courses"} />
                <AllPrograms type={"undergraduate"}  title={"Academic"} subtitle={"Tutoring"} />
                <AllPrograms type={"test"}  title={"Test"} subtitle={"Preparation"} />
                
            </Container>
           {/*  <QuranicPrograms/>
            <UndergraduatePrograms/> */}
            <Footer/>
        </>
    );


}

export default Programs;